// Uchrashuv — variant. Renders /templates/uchrashuv.html (romantic
// envelope-style date-ask, paper + wine + mauve) inside a full-bleed
// iframe. The HTML's customizer reads
// names/recipient/date/time/venue/address/phone — we map the catalog
// "names" field as "Sender & Recipient" and split it before passing.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/uchrashuv.html";

export function UchrashuvStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();

  // names = "Bobur & Aziza" → sender / recipient
  if (t.names) {
    const [sender, recipient] = t.names.split(/\s*&\s*/);
    if (sender) params.set("names", sender.trim());
    if (recipient) params.set("recipient", recipient.trim());
  }
  if (t.date) {
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  // Per-row extra surfaced via the editor — see data.ts lk02.
  const phone = typeof t.custom?.phone === "string" ? t.custom.phone.trim() : "";
  if (phone) params.set("phone", phone);
  if (ctx.slug) params.set("slug", ctx.slug);
  // ?audio=/music/<id>.mp3 — owner-picked soundtrack from the
  // curated MusicSelector library. Empty/unset = silent card.
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Uchrashuv"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F5EFE6",
      }}
    />
  );
}
